<template>
  <!-- 竞赛管理 参赛选手 -->
    <div class="board">
        <div v-hasPermi="['arrangement:examinee:list']">
            <div class="title">
                <span class="name">{{ examineeTextConfig.title }}</span>
            </div>
            <el-form :inline="true" :model="form" ref="form">
                <el-form-item>
                    <el-button type="primary" @click="openAddDialog" :disabled="examStatus ==3" v-hasPermi="['arrangement:examinee:save']">{{ examineeTextConfig.button.add }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="importDialogVisible = true" :disabled="examStatus ==3" v-hasPermi="['arrangement:examinee:import']">{{ examineeTextConfig.button.batchAdd }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="danger" @click="batchDelete()" :disabled="examStatus >=2" v-hasPermi="['arrangement:examinee:delete']">{{ examineeTextConfig.button.delete }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.examineeName" clearable :placeholder="examineeTextConfig.form.examineeNameTip"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.admissionNo" clearable :placeholder="examineeTextConfig.form.admissionNoTip"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search(1)">{{ examineeTextConfig.form.search }}</el-button>
                    <el-button @click="reset()">{{ examineeTextConfig.form.reset }}</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="tableData" v-loading="loading" element-loading-text="加载中"
                      element-loading-spinner="el-icon-loading" ref="multipleTable" stripe size="medium"
                       @selection-change="handleSelectionChange" height="500px">
                <el-table-column type="selection" min-width="48" align="center"></el-table-column>
                <el-table-column prop="examineeName" :label="tableTextConfig.examineeName" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="examineeIdcard" :label="tableTextConfig.examineeIdcard" min-width="100">
                </el-table-column>
                <el-table-column prop="admissionNo" :label="tableTextConfig.admissionNo" min-width="100">
                </el-table-column>
                <el-table-column prop="pilotSchool" :label="tableTextConfig.pilotSchool" min-width="100">
                </el-table-column>
                <el-table-column prop="assessmentSite" :label="tableTextConfig.assessmentSite" min-width="100">
                </el-table-column>
                <el-table-column prop="centreName" :label="tableTextConfig.centreName" min-width="100">
                </el-table-column>
                <el-table-column prop="seatNo" :label="tableTextConfig.seatNo" min-width="50">
                </el-table-column>
                <el-table-column :label="tableTextConfig.update" min-width="100px">
                    <template slot-scope="scope">
                        <p>{{ scope.row.updatedByUsername }}</p>
                        <p class="updateDate">{{ scope.row.updatedAt | formatTime }}</p>
                    </template>
                </el-table-column>
                <el-table-column :label="tableTextConfig.operate" width="100px">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" @click="delet(scope.row)" :disabled="examStatus >=2">
                            {{ tableTextConfig.button.delete.name }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination v-show="tableData.length" :currentPage.sync="form.pageNumber" :pageSize.sync="form.pageSize" :total.sync="total"></pagination>
            <add-examinee-dialog ref="addDialog" :examId="examId" @success="search(1)"></add-examinee-dialog>
            <import-dialog :show.sync="importDialogVisible" :examId="examId" @close="close"></import-dialog>
        </div>
    </div>
</template>

<script>
import pagination from '@/components/pagination/pagination.vue'
import {judgePermissions} from '@/utils/common.js'
import addExamineeDialog from '../../dialog/addExamineeDialog.vue'
import importDialog from '../../dialog/importExam.vue'

import request from "../../../../utils/request";

export default {
    components: {
        addExamineeDialog,pagination,importDialog
    },
    props: ['examId', 'examStatus'],
    data() {
        return {
            height: 250,
            loading: false,
            form: {
                examId: this.examId,
                examineeName: '',
                admissionNo: '',
                status: null,
                pageNumber: 1,
                pageSize: 20
            },
            total: 0,
            tableData: [],
            row: null,
            selectRow: [],
            importDialogVisible: false
        }
    },
    computed: {
        examineeTextConfig() {
            return this.$store.state.global.textConfig.backend.arrangement.examEdit.examinee
        },
        tableTextConfig() {
            return this.examineeTextConfig.table
        },
        buttonTextConfig() {
            return this.tableTextConfig.button
        },
    },
    /*beforeRouteEnter(to, from, next) {
        if (from.name === 'testPaperEdit' || from.name === 'testPaperPreview') {
            to.meta.isBack = true
        } else {
            to.meta.isBack = false
        }
        next()
    },
    activated() {
        if (!this.$route.meta.isBack) {
            this.reset()
        } else {
            this.$route.meta.isBack = false
            // this.getBorrowList() /!*列表重新加载*!/
        }
        this.$route.meta.keepAlive = true
    },*/
    methods: {
        judgePermissions,
        search(val) {
            this.loading = true
            if (val) {
                this.form.pageNumber = val
            }
            this.form.examId = this.examId
            this.$store.dispatch("getArrangeExamList", this.form).then(res => {
                if (res) {
                    this.loading = false
                    this.tableData = res.data.list
                    this.total = res.data.total
                    this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
                }
            });
            this.$nextTick(()=>{
                this.$refs.multipleTable.doLayout()
            })
        },
        reset() {
            this.form.examineeName =''
            this.form.admissionNo = ''
            this.search(1)

        },
        handleSelectionChange(val) {
            this.selectRow = []
            for (let i = 0; i < val.length; i++) {
                const e = val[i];
                this.selectRow.push(e)
            }
        },
        openAddDialog() {
            this.$refs.addDialog.open()
        },
        close() {
            this.importDialogVisible = false;
            this.search(1)
        },
        updateHeight() {
            this.height = document.getElementsByClassName('board')[0].clientHeight - document.getElementsByClassName('el-form')[0].clientHeight - 150
            this.height = this.height < 460 ? 460 : this.height
        },
        choose(tableData) {
            this.tableData = []
            for (let i = 0; i < tableData.length; i++) {
                this.tableData.push(tableData[i])
            }
        },
        delet(row) {
            let deleteTextConfig = this.tableTextConfig.button.delete
            let deleteMsg = deleteTextConfig.message.signMix(row.examineeName+"("+row.admissionNo+")")
            this.$confirm(deleteMsg, deleteTextConfig.title, {
                confirmButtonText: deleteTextConfig.ok,
                cancelButtonText: deleteTextConfig.cancel,
                type: 'warning'
            }).then(() => {
                this.$store.dispatch("deleteArrangeExam", {examId:this.examId ,ids: row.id+''}).then(res => {
                    if (res.status == 200) {
                        this.$message({
                            type: 'success',
                            message: deleteTextConfig.success
                        });
                        this.search(1)
                    }
                });
            }).catch(() => {});
        },
        batchDelete() {
            let row = []
            let deleteUser = "";
            if (this.selectRow.length == 0) {
                this.$message({
                    type: 'warning',
                    message: "请选择要删除的选手"
                });
                return
            }
            for (let j = 0; j < this.selectRow.length; j++) {
                const e = this.selectRow[j].id;
                row.push(e)
                deleteUser += this.selectRow[j].examineeName + "(" + this.selectRow[j].admissionNo + ")" + "、";
            }
            let deleteTextConfig = this.tableTextConfig.button.delete
            this.$confirm(deleteTextConfig.message.signMix(deleteUser.substring(0,deleteUser.length-1)), deleteTextConfig.title, {
                confirmButtonText: deleteTextConfig.ok,
                cancelButtonText: deleteTextConfig.cancel,
                type: 'warning'
            }).then(() => {
                this.$store.dispatch("deleteArrangeExam", {examId:this.examId, ids:row.join(',')}).then(res => {
                    if (res.status == 200) {
                        this.$message({
                            type: 'success',
                            message: deleteTextConfig.success
                        });
                        this.search(1)
                    }
                })
            }).catch(() => {});
        },
    },
    mounted() {
        const that = this;
        setTimeout(() => {
            that.updateHeight()
        }, 200);
        window.onresize = () => {
            that.updateHeight()
        };
    },
    created() {
        if (this.examId) {
            this.$store.dispatch("getArrangeExamList", this.form).then(res => {
                if (res) {
                    this.tableData = res.data.list
                    this.total = res.data.total
                }
            });
        }
    },
}
</script>

<style scoped>
</style>
